import { ThreeDots } from '@toggle/design-system';
import { Entity } from '@toggle/toggle';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { postEntities } from '~/api/entities/entity-service';

import { AssetOverviewWidget } from './AssetOverviewWidget';

interface AssetOverviewProps {
  tag: string;
}

export const AssetOverviewAssistant = ({ tag }: AssetOverviewProps) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [entity, setEntity] = useState<Entity>();
  const { t } = useTranslation('intel');

  useEffect(() => {
    const getEntity = async () => {
      const res = await postEntities({
        args: [tag],
        filter: 2,
      });

      if (res.error) {
        setError(true);
      } else {
        setEntity(res.data[0]);
      }

      setLoading(false);
    };

    getEntity();
  }, [tag]);

  if (loading) {
    return <ThreeDots />;
  }

  if (error || !entity) {
    return <p>{t('intel:empty')}</p>;
  }

  return <AssetOverviewWidget entity={entity} />;
};
